import { render, staticRenderFns } from "./ProfileAvatar.vue?vue&type=template&id=08c02414&scoped=true"
import script from "./ProfileAvatar.vue?vue&type=script&lang=js"
export * from "./ProfileAvatar.vue?vue&type=script&lang=js"
import style0 from "./ProfileAvatar.vue?vue&type=style&index=0&id=08c02414&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c02414",
  null
  
)

export default component.exports